import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa"; // Using react-icons for the checkmark
import logoLight from "../../../../Components/logo.png";
import logoDark from "../../../../Components/logo-dark.png";
import { useThemeMode } from "../../../../theme/ThemeModeContext";

const Welcome = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const location = useLocation();
  const { resolvedTheme } = useThemeMode();
  const Logo = resolvedTheme === "dark" ? logoDark : logoLight;

  const redirectMe = (url) => {
    window.location.href = url;
  };

  return (
    <div className="min-h-screen bg-ui-bg flex items-center justify-center py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-ui-surface rounded-2xl p-8 text-center transform transition-all duration-500 hover:scale-105">
        {/* Logo */}
        <div className="mb-6">
          <img
            src={Logo}
            alt={t("login.logoAlt")}
            className="h-10 mx-auto cursor-pointer"
            onClick={() => redirectMe("https://hajexbolt.com/")}
          />
        </div>

        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <FaCheckCircle className="h-12 w-12 text-state-success-text animate-bounce" />
        </div>

        {/* Heading */}
        <h1 className="text-3xl font-extrabold text-text-brand mb-3">
          {t("welcome.heading", { name: location.state?.username ?? "" })}
        </h1>

        {/* Subheading */}
        <p className="text-base text-ui-text-muted mb-6">
          <Trans
            t={t}
            i18nKey="welcome.body"
            values={{ email: location.state?.email ?? "" }}
            components={{
              email: <span className="font-semibold text-brand" />,
            }}
          />
        </p>

        {/* Button */}
        <button
          onClick={() => redirectMe("https://hajexbolt.com/")}
          className="w-full bg-brand hover:bg-brand-hover text-ui-surface font-semibold py-2.5 px-6 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-brand hover:"
        >
          {t("welcome.returnHome")}
        </button>

        {/* Footer */}
        <p className="text-xs text-ui-text-muted mt-6">
          {t("welcome.questions")}{" "}
          <a
            href="mailto:info@hajexbolt.com"
            className="text-brand hover:text-brand-hover font-semibold"
          >
            info@hajexbolt.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default Welcome;
